import React, { useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import LoadSimple from '../../LoadSimple';
import InternalError from '../../generales/InternalError';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';

const ModalFlowNew = ({ eventId, props, onClose }) => {
  const token_item = localStorage.getItem('access_token');
  const [dataFlujo, setDataFlujo] = useState({ data: [], loading: true, error: null });
  const [internalError, setInternalError] = useState(false);

  useEffect(() => {
    search_event();
  }, []);

  const search_event = async () => {
    setDataFlujo({ data: [], loading: true, error: null });
    try {
      const url = (props.data.alert_type === "correlation")
        ? props.server.url + '/api/v1/cassia/events_correlations/acknowledge/' + eventId
        : props.server.url + '/api/v1/zabbix/problems/acknowledge/' + eventId + '?is_cassia_event=' + ((props.data.alert_type === "") ? 0 : 1);

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token_item}`,
        },
      });
      if (response.ok) {
        const response_data = await response.json();
        setDataFlujo({ data: response_data.data, loading: false, error: null });
      } else {
        throw new Error('Error en la solicitud');
      }
    } catch (error) {
      setInternalError(true);
    }
  };

  const formatEventDuration = (hoursDecimal) => {
    if (!hoursDecimal) return "0m";
    const hoursNum = parseFloat(hoursDecimal.toString().replace('hrs.', ''));
    const totalMinutes = Math.floor(hoursNum * 60);
    const days = Math.floor(totalMinutes / (24 * 60));
    const remainingMinutesAfterDays = totalMinutes % (24 * 60);
    const hours = Math.floor(remainingMinutesAfterDays / 60);
    const minutes = remainingMinutesAfterDays % 60;

    let result = "";
    if (days > 0) result += `${days}d `;
    if (hours > 0 || days > 0) result += `${hours}h `;
    result += `${minutes}m`;
    return result.trim();
  };

  const handleExport = () => {
    const input = document.getElementById('flow-modal-content');
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 100);
      pdf.save(`flujo-${eventId}-${new Date().getTime()}.pdf`);
    });
  };

  const getTagStyle = (tipoLabel) => {
    const label = (tipoLabel || '').toLowerCase();
    let colorProps;

    if (label.includes('creación de evento') || label.includes('creacion de evento'))
      colorProps = { background: '#1a56db', color: '#fff', border: 'none' };
    else if (label.includes('recuperación') || label.includes('recuperacion'))
      colorProps = { background: '#fff', color: '#1a56db', border: '1px solid #93c5fd' };
    else if (label.includes('acknowledge'))
      colorProps = { background: '#7e3af2', color: '#fff', border: 'none' };
    else if (label.includes('ticket'))
      colorProps = { background: '#057a55', color: '#fff', border: 'none' };
    else if (label.includes('excepción') || label.includes('excepcion'))
      colorProps = { background: '#d97706', color: '#fff', border: 'none' };
    else
      colorProps = { background: '#64748b', color: '#fff', border: 'none' };

    return {
      display: 'inline-block',
      borderRadius: 5,
      padding: '3px 10px',
      fontSize: 10,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      ...colorProps
    };
  };

  if (internalError) return <InternalError />;

  const allData = dataFlujo.data || [];
  const progressStep = allData.find(d => d.type === "Progreso del evento a la fecha.");
  const pasos = allData.filter(d => d.type !== "Progreso del evento a la fecha.");

  const estadoFinal = props.data.Estatus === 'RESOLVED' ? 'RESUELTO' : 'En proceso';
  const tiempoAcumulado = progressStep ? formatEventDuration(progressStep.message.replace('Acumulado del evento:', '')) : '0m';

  // Renderiza la card de contenido (sin dot)
  const StepCard = ({ paso, align }) => {
    const tipoLabel = capitalizeFirstLetter(lang[props.languaje][paso.type]) || paso.type;
    const isRight = align === 'right';
    return (
      <div style={{
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        background: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,.06)',
        overflow: 'hidden'
      }}>
        {/* Header: tag y fecha. En cards derechas se invierte con row-reverse */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: isRight ? 'row-reverse' : 'row',
          justifyContent: 'space-between',
          padding: '8px 11px',
          borderBottom: '1px solid #f1f5f9',
          gap: 6
        }}>
          <span style={getTagStyle(paso.type)}>{tipoLabel}</span>
          <span style={{ fontSize: 9, fontFamily: 'monospace', color: '#64748b', flexShrink: 0 }}>
            {paso.date.replace('T', ' ')}
          </span>
        </div>
        <div style={{ padding: '10px 11px' }}>
          <div style={{ fontSize: 11, color: '#334155', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
            {(paso.ticket_id === undefined) ? paso.message.replaceAll('-', '\n') : 'Tracker ID: ' + paso.tracker_id}
          </div>
          <div style={{ fontSize: 10, fontWeight: 500, color: '#334155', marginTop: 6 }}>
            {(paso.ticket_id === undefined) ? paso.user : 'Ticket'}
          </div>
        </div>
      </div>
    );
  };

  // Renderiza un paso normal con la estructura de 3 columnas:
  // [ mitad izquierda ] [ columna central 44px con dot ] [ mitad derecha ]
  const renderStep = (paso, index) => {
    const isLeft = index % 2 === 0;
    return (
      <div key={index} style={{
        display: 'flex',
        alignItems: 'flex-start',
        position: 'relative',
        marginBottom: 14
      }}>
        {/* MITAD IZQUIERDA */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {isLeft ? <StepCard paso={paso} align="left" /> : null}
        </div>

        {/* COLUMNA CENTRAL — dot siempre aquí, centrado sobre la línea */}
        <div style={{
          width: 44,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: 14,
          zIndex: 2
        }}>
          <div style={{
            width: 11,
            height: 11,
            borderRadius: '50%',
            background: '#1a56db',
            border: '2.5px solid #fff',
            boxShadow: '0 0 0 1.5px #1a56db'
          }} />
        </div>

        {/* MITAD DERECHA */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {!isLeft ? <StepCard paso={paso} align="right" /> : null}
        </div>
      </div>
    );
  };

  // Renderiza el paso RESUELTO — siempre al final, centrado
  const renderResolvedStep = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      marginTop: 4,
      position: 'relative'
    }}>
      <div style={{
        width: '60%',
        border: '1.5px solid #057a55',
        borderRadius: 8,
        background: '#fff',
        boxShadow: '0 1px 6px rgba(5,122,85,.1)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 14px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <span style={{
              display: 'flex', alignItems: 'center', gap: 5,
              background: '#057a55', color: '#fff',
              borderRadius: 5, padding: '4px 12px',
              fontSize: 11, fontWeight: 600
            }}>
              ✓ RESUELTO
            </span>
            <span style={{ fontSize: 9, color: '#64748b' }}>Estado final del evento</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
            <span style={{ fontSize: 9, color: '#64748b' }}>Tiempo acumulado</span>
            <span style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', fontFamily: 'monospace' }}>
              {tiempoAcumulado}
            </span>
          </div>
        </div>
      </div>
      {/* Dot verde centrado sobre la línea */}
      <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 11, height: 11,
        borderRadius: '50%',
        background: '#057a55',
        border: '2.5px solid #fff',
        boxShadow: '0 0 0 1.5px #057a55',
        zIndex: 3
      }} />
    </div>
  );

  return (
    <div style={{
      background: 'rgba(15,30,56,0.55)',
      backdropFilter: 'blur(2px)',
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 50
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        width: '100%',
        height: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.05)',
        overflow: 'hidden',
        display: 'flex', flexDirection: 'column',

        animation: 'slideUp 0.2s ease'
      }} id="flow-modal-content">
        <style>{`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(12px) }
            to   { opacity: 1; transform: translateY(0) }
          }
          .timeline-body::-webkit-scrollbar { width: 4px; }
          .timeline-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        `}</style>

        {/* HEADER */}
        <div style={{ background: '#0f2d5e', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: 'rgba(255,255,255,.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="3" r="1.2" fill="#fff" />
                <line x1="8" y1="5" x2="8" y2="13" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" />
                <circle cx="8" cy="6.5" r="1" fill="#fff" opacity=".4" />
                <circle cx="8" cy="9" r="1" fill="#fff" opacity=".65" />
                <circle cx="8" cy="11.5" r="1" fill="#fff" opacity=".85" />
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>
                {capitalizeFirstLetter(lang[props.languaje]['flujoEvento'])}
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,.5)', marginTop: 1 }}>
                Línea de tiempo de acciones registradas
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <button style={{
              display: 'flex', alignItems: 'center', gap: 5,
              border: '0.5px solid rgba(255,255,255,.2)',
              background: 'rgba(255,255,255,.1)',
              borderRadius: 6, padding: '5px 10px',
              fontSize: 10, color: 'rgba(255,255,255,.85)', cursor: 'pointer'
            }} onClick={handleExport}>
              Exportar
            </button>
            <button style={{
              width: 26, height: 26, borderRadius: 6,
              border: '0.5px solid rgba(255,255,255,.15)',
              background: 'rgba(255,255,255,.08)',
              cursor: 'pointer', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: 'rgba(255,255,255,.6)'
            }} onClick={onClose}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
        </div>

        {/* META BAR */}
        <div style={{ background: '#f1f5f9', borderBottom: '1px solid #e2e8f0', padding: '7px 18px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Event ID</span>
            <span style={{ fontFamily: 'monospace', fontSize: 10, fontWeight: 600, color: '#1a56db', background: '#e8f0fe', border: '1px solid #c3dafe', borderRadius: 4, padding: '2px 8px' }}>
              {eventId}
            </span>
          </div>
          <span style={{ color: '#cbd5e1' }}>|</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Estado final</span>
            <span style={{
              background: props.data.Estatus === 'RESOLVED' ? '#d1fae5' : '#fee2e2',
              color: props.data.Estatus === 'RESOLVED' ? '#057a55' : '#e02424',
              border: `1px solid ${props.data.Estatus === 'RESOLVED' ? '#a7f3d0' : '#fca5a5'}`,
              borderRadius: 4, padding: '2px 8px', fontSize: 10, fontWeight: 600
            }}>
              ● {estadoFinal}
            </span>
          </div>
          <span style={{ color: '#cbd5e1' }}>|</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>Acumulado</span>
            <span style={{ fontFamily: 'monospace', fontSize: 11, fontWeight: 600, color: '#334155' }}>
              {tiempoAcumulado}
            </span>
          </div>
          <div style={{ marginLeft: 'auto', fontSize: 9, color: '#64748b' }}>
            {pasos.length} acciones registradas
          </div>
        </div>

        {/* TIMELINE BODY */}
        <div className="timeline-body" style={{ padding: '20px 0 16px', overflowY: 'auto', flex: 1, position: 'relative' }}>
          {dataFlujo.loading ? <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><LoadSimple /></div> : (
            <div style={{ position: 'relative', padding: '0 20px' }}>
              {/* Línea central roja — centrada en el contenedor (coincide con la columna de 44px) */}
              <div style={{
                position: 'absolute',
                left: '50%',
                top: 0, bottom: 0,
                width: 2,
                background: '#e02424',
                transform: 'translateX(-50%)',
                opacity: 0.5,
                zIndex: 0
              }} />

              {/* Pasos normales con estructura 3 columnas */}
              <div style={{ position: 'relative', zIndex: 1 }}>
                {pasos.map((paso, i) => renderStep(paso, i))}
              </div>

              {/* Paso RESUELTO — siempre al final, fuera del map */}
              {props.data.Estatus === 'RESOLVED' && (
                <div style={{ position: 'relative', zIndex: 1, marginTop: 4 }}>
                  {renderResolvedStep()}
                </div>
              )}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div style={{ padding: '10px 18px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid #e2e8f0', background: '#f1f5f9', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 10, color: '#64748b' }}>
            Pasos registrados:
            <span style={{ background: '#e8f0fe', color: '#1a56db', border: '1px solid #c3dafe', borderRadius: 10, padding: '1px 7px', fontSize: 9, fontFamily: 'monospace' }}>
              {pasos.length}
            </span>
          </div>
          <button style={{
            display: 'flex', alignItems: 'center', gap: 5,
            borderRadius: 7, fontSize: 11, fontWeight: 500,
            padding: '7px 16px', cursor: 'pointer',
            border: '1px solid #e2e8f0',
            background: '#fff', color: '#334155'
          }} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalFlowNew;
